import getWithToken from './base/get-with-token'

const getMapDataDams = getWithToken('/map-data/dam')

export default getMapDataDams